<template>
  <div class="hidden" />
</template>

<script setup>
const { t } = useI18n();
const { $eventBus, $toast } = useNuxtApp();
const route = useRoute();
const pendingToast = useState('toast.pending', () => null);

const toastSuccess = (message) => {
  $toast.success(t(message));
};

const toastError = (message) => {
  $toast.error(t(message));
};

const flushPendingToast = () => {
  if (!pendingToast.value?.type || !pendingToast.value?.message) {
    return;
  }

  if (pendingToast.value.type === 'success') {
    toastSuccess(pendingToast.value.message);
  } else if (pendingToast.value.type === 'error') {
    toastError(pendingToast.value.message);
  }

  pendingToast.value = null;
};

onMounted(async () => {
  $eventBus.on('toast:success', toastSuccess);
  $eventBus.on('toast:error', toastError);
});

watch(() => route.fullPath, flushPendingToast);

onUnmounted(() => {
  $eventBus.off('toast:success', toastSuccess);
  $eventBus.off('toast:error', toastError);
});

</script>
